<template>
  <div style="display: none;">
    <!-- This component doesn't render anything visible -->
  </div>
</template>

<script>
export default {
  name: 'SEOHead',
  props: {
    title: {
      type: String,
      default: 'Rwanda Kigali Selfdrive | Car Rental Rwanda +250788539359'
    },
    description: {
      type: String,
      default: '#1 Car Rental in Rwanda. Rent Land Cruisers, SUVs & 4x4s for gorilla trekking & safaris. Full insurance, airport pickup, 24/7 support. Book now!'
    },
    keywords: {
      type: String,
      default: 'car rental rwanda, rwanda kigali selfdrive, rent car kigali, car hire rwanda, 4x4 rental rwanda, gorilla trekking car, safari car rental, land cruiser rental, airport car rental kigali, self drive rwanda, suv rental rwanda, cheap car rental rwanda, luxury car hire kigali, volcanoes national park car, akagera safari vehicle, nyungwe forest transport, lake kivu car rental, kigali airport transfer, rwanda road trip car, budget car rental kigali'
    },
    image: {
      type: String,
      default: 'https://rwandakigaliselfdrive.com/images/logo.png'
    },
    url: {
      type: String,
      default: 'https://rwandakigaliselfdrive.com'
    },
    type: {
      type: String,
      default: 'website'
    }
  },
  mounted () {
    this.updateMetaTags()
  },
  updated () {
    this.updateMetaTags()
  },
  methods: {
    updateMetaTags () {
      // Update title
      document.title = this.title

      // Update meta description
      this.updateMetaTag('description', this.description)
      this.updateMetaTag('og:description', this.description)
      this.updateMetaTag('twitter:description', this.description)

      // Update meta keywords
      this.updateMetaTag('keywords', this.keywords)

      // Update Open Graph tags
      this.updateMetaTag('og:title', this.title)
      this.updateMetaTag('og:url', this.url)
      this.updateMetaTag('og:image', this.image)
      this.updateMetaTag('og:type', this.type)

      // Update Twitter Card tags
      this.updateMetaTag('twitter:title', this.title)
      this.updateMetaTag('twitter:url', this.url)
      this.updateMetaTag('twitter:image', this.image)

      // Update canonical URL
      this.updateCanonicalUrl(this.url)
    },
    updateMetaTag (name, content) {
      let meta = document.querySelector(`meta[name="${name}"]`)
      if (!meta) {
        meta = document.querySelector(`meta[property="${name}"]`)
      }
      if (!meta) {
        meta = document.createElement('meta')
        if (name.startsWith('og:') || name.startsWith('twitter:')) {
          meta.setAttribute('property', name)
        } else {
          meta.setAttribute('name', name)
        }
        document.head.appendChild(meta)
      }
      meta.setAttribute('content', content)
    },
    updateCanonicalUrl (url) {
      let canonical = document.querySelector('link[rel="canonical"]')
      if (!canonical) {
        canonical = document.createElement('link')
        canonical.setAttribute('rel', 'canonical')
        document.head.appendChild(canonical)
      }
      canonical.setAttribute('href', url)
    }
  }
}
</script>
